define('wax-resist-head',["wax-resist-common"], function(resist) {

  var head = document.querySelector("header");

  var isTouch = false;
  try {
    document.createEvent("TouchEvent");
    isTouch = true;
  } catch (_) {}

  var canvas = document.querySelector("canvas.smudge");
  if (!canvas) return; //page 2, other pages without this header
  
  var context = canvas.getContext("2d");
  resist.init(context);

  var across = {
    start: {
      x: 0,
      y: .5
    },
    end: {
      x: 1,
      y: .5
    },
    duration: 200
  };

  var through = {
    start: {
      x: 0,
      y: .3
    },
    end: {
      x: 1,
      y: .7
    },
    ease: true
  };

  resist.loadPattern(context, "../assets/texture.jpg", function() {
    //intro animation
    var r = canvas.width / 15;
    resist.animate(context, isTouch ? across : through, function(x, y) {
      resist.revealPoly(context, x, y, (Math.random() * .2 + .8) * r);
      if (!isTouch) resist.speckle(context, x, y, r);
    });
  });

  resist.bindMouse(head, context, canvas.width / 15);
  resist.bindTouch(head, context);

  //suppress scrolls on the header to allow easier reveal
  head.addEventListener("touchstart", function(e) { e.preventDefault() });

});
